<script setup lang="ts">
// The HQ brand Q monogram as an inline OUTLINED SVG - the real Alfa Slab One Q
// (identical to favicon.svg and the app icons), so it carries no webfont
// dependency and never flashes a fallback serif while a font loads. The yellow
// chip + navy Q are baked in (the mark is the same in light and dark); the
// parent sizes it via width/height. It's decorative - callers keep aria-hidden
// on the surrounding context. Path generated from the brand font; see
// apps/site/tools/icon-export.
</script>

<template>
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#FACC15" />
    <path
      transform="translate(32 32) scale(0.046 -0.046) translate(-404 -357)"
      fill="#0A1F44"
      d="M794 -78Q582 -78 454.5 -65Q327 -52 235 -9.5Q143 33 81 118Q14 215 14 389Q14 592 114.5 692Q215 792 396 792Q576 792 677 703.5Q778 615 778 439Q778 363 753.5 296.5Q729 230 669 174L674 164L794 164L794 -78ZM396 164Q464 164 464 238L464 540Q464 614 396 614Q328 614 328 540L328 238Q328 164 396 164Z"
    />
  </svg>
</template>

<style scoped>
svg { display: block; }
</style>
